import { render } from "./ItemSelectBox.vue?vue&type=template&id=5fcb5000"
import script from "./ItemSelectBox.vue?vue&type=script&lang=js"
export * from "./ItemSelectBox.vue?vue&type=script&lang=js"
script.render = render

export default script